import { Brain, Target, BarChart2, Zap, ShieldCheck, Search } from 'lucide-react'
import { useScrollReveal } from '@/hooks/useScrollReveal'

const BENEFITS = [
  { icon: Brain, label: 'IA especializada en fútbol' },
  { icon: Target, label: 'Solo picks Prematch' },
  { icon: BarChart2, label: 'Datos reales verificados' },
  { icon: Zap, label: 'Sin apuestas en vivo' },
  { icon: ShieldCheck, label: 'Transparencia total' },
  { icon: Search, label: 'Resultados auditados' },
]

export function BenefitsBar() {
  const ref = useScrollReveal<HTMLElement>()

  return (
    <section
      ref={ref}
      className="border-y border-border bg-panel/60 backdrop-blur-sm"
    >
      <div className="max-w-5xl mx-auto px-5 py-5">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {BENEFITS.map((b, i) => (
            <div
              key={b.label}
              className={`reveal flex items-center gap-2.5 stagger-${i + 1}`}
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <div className="flex-shrink-0 h-7 w-7 rounded-lg bg-brand-soft flex items-center justify-center">
                <b.icon className="h-3.5 w-3.5 text-brand" />
              </div>
              <span className="text-xs font-medium text-text-dim leading-snug">{b.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
